import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = {
  class: "anchor fw-bolder mb-5",
  id: "z-index"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Z-Index ")
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".z-index-{value}"),
  /*#__PURE__*/_createTextVNode(" class to set an element's z-index: ")
], -1)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Where ")
const _hoisted_7 = /*#__PURE__*/_createVNode("code", null, "value", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" is one of: ")
const _hoisted_9 = { class: "pt-3" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" - for classes that set z-index ")
const _hoisted_11 = { class: "py-5" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`
        <div class="z-index-n1"></div>
        <div class="z-index-n2"></div>
        <div class="z-index-0"></div>
        <div class="z-index-1"></div>
        <div class="z-index-2"></div>
        <div class="z-index-3"></div>
        `))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/documentation/utilities#z-index" }),
      _hoisted_3
    ]),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _createVNode("ul", _hoisted_9, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.zIndexValues, (key, value, i) => {
          return (_openBlock(), _createBlock("li", {
            key: i,
            class: "py-2"
          }, [
            _createVNode("code", null, _toDisplayString(key), 1),
            _hoisted_10,
            _createVNode("code", null, _toDisplayString(key), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      })
    ])
  ]))
}